import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/rjsf-shim.scss';
import './index.css';
import './App.css';
import App from './App';
import FaviconLinks from './shared/components/FaviconLinks';
import { applyDocumentTitle } from './shared/utils/documentTitle';

applyDocumentTitle('Maintella – empower your field engineers');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <FaviconLinks />
    <App />
  </React.StrictMode>
);
